module.exports = __webpack_public_path__ + "static/media/Pouť-94-2.8ca54329.jpg";